module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "footer bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "footer-copyright text-center border-top border-gray-light"
  }, [_c('span', {
    staticClass: "font-family-alt letter-spacing-1 text-gray-dark text-small text-uppercase"
  }, [_vm._v("\n                            " + _vm._s(_vm.year) + " © Volkswagen ErhvervsCenter " + _vm._s(this.$route.meta.retailerName) + ". Udviklet af "), _vm._m(0, false, false), _vm._v(".\n                        ")])])])])])]), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://deveo.dk"
    }
  }, [_c('u', [_vm._v("Deveo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-scroll scroll-to-top",
    attrs: {
      "href": "#page-top"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebecd11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
// module id = 242
// module chunks = 1